import { useState } from "react";

import RenderIf from "common/components/RenderIf";
import { getWhitelabelCustomization } from "common/helpers/utils";

import Communication from "./Communication";
import Email from "./Email";
import FullName from "./FullName";
import Password from "./Password";

export default function ProfileSettings() {
  const { whitelabelCustomization } = getWhitelabelCustomization();
  const [editingKey, setEditingKey] = useState<"name" | "email" | "password">(
    null,
  );

  function closeEditing() {
    setEditingKey(null);
  }

  return (
    <div>
      <FullName
        isEditable={!whitelabelCustomization}
        isEditing={editingKey === "name"}
        startEditing={() => setEditingKey("name")}
        closeEditing={closeEditing}
      />
      <Email
        isEditable={!whitelabelCustomization}
        isEditing={editingKey === "email"}
        startEditing={() => setEditingKey("email")}
        closeEditing={closeEditing}
      />
      <RenderIf condition={!whitelabelCustomization}>
        <Password
          isEditing={editingKey === "password"}
          startEditing={() => setEditingKey("password")}
          closeEditing={closeEditing}
        />
        <Communication />
      </RenderIf>
    </div>
  );
}
